import api from './api-service'
import i18n from '../i18n'

export default {
    // Item: {product, quantity}
    getCorrectQuantity(product, quantity) {
        var newQuantity = quantity ? quantity : product.product_group.minimum_quantity_per_product
        const correctQuantity = newQuantity % product.product_group.minimum_quantity_per_product == 0 ? newQuantity : Math.ceil(newQuantity/product.product_group.minimum_quantity_per_product)*product.product_group.minimum_quantity_per_product  
        return parseInt(correctQuantity)
    },

    // Item: {product, quantity}
    getCorrectPrice(item) {
        const possiblePrices = item.product.prices.filter(price => price.quantity_range_start <= item.quantity)
        return parseFloat(possiblePrices[possiblePrices.length - 1].price)
    },

    getProducts(search, tags, size, page) {
        const fetchUrl = `/filtered_products.json`;
        const body = {
            search: search,
            tags: tags,
            size: size,
            page: page
        }
       return api.retrieveWithBody(fetchUrl, i18n.t('responses.products'), body)
    },

    getManualInputProducts(id) {
       return api.retrieve(`/manual_input/${id}.json`, i18n.t('responses.products'))
    },

    getProductById(id) {
        return api.retrieve(`/product/${id}.json`, i18n.t('responses.product'))
    },

    getTags() {
        return api.retrieve('/tags.json', i18n.t('responses.filters'))
    },
}